module.exports = __webpack_public_path__ + "img/__icon_JUMBO.883bee49.svg";